import React from 'react';
import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

import { DataGrid } from '@mui/x-data-grid';
import {Office} from "../../../classes/Office";

function OfficeFlatList(props: {
    data: Office[],
    selectedOfficeId?: number,
    onOfficeSelectionChanged: Function,
    sx?: object
}) {

    // TODO: Add more information to this space.
    const columns = [
        { field: 'name', headerName: 'Name', width: 400 },
    ];

    return (
        <Paper sx={props.sx}>
            <Stack direction="column" spacing={2} padding={2}>
                <Box sx={{ height: 600 }}>
                    <DataGrid
                        rows={props.data.map((office: Office) => office.objectify())}
                        columns={columns}
                        rowSelectionModel={props.selectedOfficeId === undefined ? [] : props.selectedOfficeId!}
                        onRowSelectionModelChange={(e) => props.onOfficeSelectionChanged(e)}
                    />
                </Box>
            </Stack>
        </Paper>
    )
}

export default OfficeFlatList